// extracted by extract-css-chunks-webpack-plugin
module.exports = {"content":"content___1Lv90","imageblock":"imageblock___3YPIG","periodical":"periodical___35zZw","empahsize":"empahsize___1pW_V"};